var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_238_1296)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 0H0L100 100H0L100 200H200L100 100H200L100 0Z",
    fill: "url(#paint0_linear_238_1296)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_238_1296",
    x1: 20.5,
    y1: 16,
    x2: 100,
    y2: 200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACAAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0E8FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_238_1296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon6.e1ec7930074e5062b9ec4c99d03dab3a.svg";
export { ForwardRef as ReactComponent };